//import { EventDetails } from "store/qlapi/EpgService"
import { logErrorInfo } from "utils/BugsnagReporter"

// exclude EventDetails and onClick function from comparison
export const deepEqual = (obj1, obj2) => {
	//console.debug("deepEqual start", obj1, obj2)
	try {
		//console.debug("obj1 %o, obj2 %o", obj1, obj2)
		// MTVW-1157: commented EventDetails
		//if (obj1 instanceof EventDetails && obj2 instanceof EventDetails) return true
		if (obj1 === null && obj2 === null) return true
		if (obj1 === null && obj2 !== null || obj2 === null && obj1 !== null) return false
		const keys1 = Object.keys(obj1);
		const keys2 = Object.keys(obj2);
		if (keys1?.length !== keys2?.length) {
			//console.debug("deepEqual", keys1?.length, keys1, keys2?.length, keys2)
			return false;
		}
		for (const key of keys1) {
			//console.debug("deepEqual key", key)
			if (key === "onClick") return true
			// discard "inlineLane" for HeroTile
			if (key === "inlineLane") return true
			if (!obj2.hasOwnProperty(key)) {
				//console.debug("deepEqual hasOwnProperty", obj2, key)
				return false;
			}
			if (typeof obj1[key] === 'object' && typeof obj2[key] === 'object') {
				if (!deepEqual(obj1[key], obj2[key])) {
					//console.debug("deepEqual recursion", obj1[key], obj2[key])
					return false;
				}
			} else {
				if (obj1[key] !== obj2[key]) {
					//console.debug("deepEqual keys NOT equal key %o, obj1 %o, type1 %o, obj2 %o, type2 %o", key, obj1[key], typeof obj1[key], obj2[key], typeof obj2[key])
					//if (typeof obj1[key] === "function" && typeof obj2[key] === "function") return true
					return false;
				}
			}
		}
	}
	catch (e) {
		console.error("deepEqual", e, obj1, obj2)
		logErrorInfo(e, "deepEqual", obj1, obj2)
	}
	return true;
}

// intended to compare objects of identical shape, ideally static.
//
// any top-level key with a primitive value which exists in `previous` but not
// in `current` returns `undefined` while vice versa yields a diff.
//
// in general, the input type determines the output type. that is if `previous`
// and `current` are objects then an object is returned. if arrays then an array
// is returned, etc.

/* DOESN't work reliably if one one of the objecs is empty
export const getChanges = (previous, current) => {
	if (isPrimitive(previous) && isPrimitive(current)) {
		if (previous === current) {
			return ""
		}

		return current
	}

	if (isObject(previous) && isObject(current)) {
		const diff = getChanges(Object.entries(previous), Object.entries(current))

		return diff.reduce((merged, [key, value]) => {
			return {
				...merged,
				[key]: value
			}
		}, {})
	}

	const changes = []

	if (JSON.stringify(previous) === JSON.stringify(current)) {
		return changes
	}

	for (let i = 0; i < current?.length; i++) {
		const item = current[i]

		if (JSON.stringify(item) !== JSON.stringify(previous[i])) {
			changes.push(item)
		}
	}

	return changes
}

const typeOf = o => Object.prototype.toString.call(o)
const isObject = o => o !== null && !Array.isArray(o) && typeOf(o).split(" ")[1].slice(0, -1) === "Object"

export const isPrimitive = o => {
	switch (typeof o) {
		case "object": {
			return false
		}
		case "function": {
			return false
		}
		default: {
			return true
		}
	}
}
*/
